"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAudit = exports.UserRole = exports.REAL_NAME_AUTH = exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType["PERSONAL"] = "personal";
    UserType["COMPANY"] = "company";
})(UserType = exports.UserType || (exports.UserType = {}));
// 用户认证状态 实名认证状态，1-未认证，2-已认证，3-认证失败，4-待审核
var REAL_NAME_AUTH;
(function (REAL_NAME_AUTH) {
    REAL_NAME_AUTH[REAL_NAME_AUTH["NOT_AUTH"] = 1] = "NOT_AUTH";
    REAL_NAME_AUTH[REAL_NAME_AUTH["AUTH_SUCCESS"] = 2] = "AUTH_SUCCESS";
    REAL_NAME_AUTH[REAL_NAME_AUTH["AUTH_FAIL"] = 3] = "AUTH_FAIL";
    REAL_NAME_AUTH[REAL_NAME_AUTH["WAITTING_AUTH"] = 4] = "WAITTING_AUTH";
})(REAL_NAME_AUTH = exports.REAL_NAME_AUTH || (exports.REAL_NAME_AUTH = {}));
// 用户角色
var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "super_admin";
    UserRole["SENIOR_ADMIN"] = "senior_admin";
    UserRole["GENERAL_ADMIN"] = "general_admin";
    UserRole["OPS_ADMIN"] = "ops_admin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
// 单位认证状态
var CompanyAudit;
(function (CompanyAudit) {
    CompanyAudit[CompanyAudit["UN_AUDIT"] = 1] = "UN_AUDIT";
    CompanyAudit[CompanyAudit["NOT_AUDIT"] = 2] = "NOT_AUDIT";
    CompanyAudit[CompanyAudit["AUDIT_SUCCESS"] = 3] = "AUDIT_SUCCESS";
    CompanyAudit[CompanyAudit["AUDIT_FAIL"] = 4] = "AUDIT_FAIL";
})(CompanyAudit = exports.CompanyAudit || (exports.CompanyAudit = {}));
